import React, { useState } from "react";
import { Card, Button, Form } from "react-bootstrap";
import TextareaAutosize from "react-textarea-autosize";
import { analyze } from "../../services/Engine";
import {
  updateTrainingData,
  deleteTrainingData,
} from "../../services/Settings";

export default function DataTable(props) {
  function DataRow(props) {
    const BUTTON_TITLE_UPDATE = "Update";
    const BUTTON_TITLE_DELETE = "Delete entry";
    const BUTTON_TITLE_DELETING = "Deleting entry";
    const BUTTON_TITLE_DELETED = "Deleted";
    const BUTTON_TITLE_DONE = "Updated";
    const BUTTON_TITLE_TRY_AGAIN = "Try again";
    const BUTTON_TITLE_ADDING_DATA = "Adding training data...";
    const BUTTON_TITLE_CONTACTING_ENGINE = "Contacting anaylsis engine...";

    const [deleteButtonState, setDeleteButtonState] = useState({
      title: BUTTON_TITLE_DELETE,
      disabled: false,
    });
    const [buttonState, setButtonState] = useState({
      title: BUTTON_TITLE_UPDATE,
      disabled: false,
    });
    const NEGATIVE = -1;
    const NEUTRAL = 0;
    const POSITIVE = 1;
    const [title, setTitle] = useState(props.row.title);
    const [text, setText] = useState(props.row.text);
    const [summary, setSummary] = useState(props.row.summary);
    const [sentiment, setSentiment] = useState(
      parseSentimentorSignificance(props.row.sentiment)
    );
    const [significance, setSignificance] = useState(
      parseSentimentorSignificance(props.row.significance)
    );
    const [awsSentiment, setAwsSentiment] = useState(
      parseSentimentAnalysis(props.row.aws_sentiment)
    );
    async function onDelete() {
      setDeleteButtonState({ title: BUTTON_TITLE_DELETING, disabled: true });
      setButtonState({ title: BUTTON_TITLE_DELETING, disabled: true });
      try {
        await deleteTrainingData(props.row.dataId);
        setDeleteButtonState({ title: BUTTON_TITLE_DELETED, disabled: true });
        setButtonState({ title: BUTTON_TITLE_DELETED, disabled: true });
      } catch (err) {
        setDeleteButtonState({ title: BUTTON_TITLE_DELETE, disabled: false });
        setButtonState({ title: BUTTON_TITLE_UPDATE, disabled: false });
      }
    }
    async function onSubmit() {
      if (title && text && summary) {
        const values = {
          entry: props.row.entry,
          dataId: props.row.dataId,
          title: title,
          text: text,
          summary: summary,
          sentiment: sentiment,
          significance: significance,
          aws_sentiment: props.row.aws_sentiment,
        };
        setButtonState({
          title: BUTTON_TITLE_CONTACTING_ENGINE,
          disabled: true,
        });
        setDeleteButtonState({ title: BUTTON_TITLE_DELETE, disabled: true });
        try {
          const result = await analyze('comprehend', {
            text: summary,
            testOnly: true,
          });
          values.aws_sentiment = updateSentimentAnalysis(result.analysis);
        } catch (err) {
          //mostly due to text being too large
          //leave aws_sentiment empty in this case
          updateSentimentAnalysis();
        }
        setButtonState({ title: BUTTON_TITLE_ADDING_DATA, disabled: true });
        try {
          await updateTrainingData(values);
          setButtonState({ title: BUTTON_TITLE_DONE, disabled: true });
          setDeleteButtonState({ title: BUTTON_TITLE_DELETE, disabled: false });
        } catch (err) {
          console.log("error", err);
          setButtonState({ title: BUTTON_TITLE_TRY_AGAIN, disabled: false });
          setDeleteButtonState({ title: BUTTON_TITLE_DELETE, disabled: false });
        }
      } else {
        return null;
      }
    }

    function parseSentimentAnalysis(value) {
      switch (value) {
        case -1:
          return { code: -1, sentiment: "Negative" };
        case 0:
          return { code: 0, sentiment: "Neutral" };
        case 1:
          return { code: 1, sentiment: "Positive" };
        default:
          return { code: null, sentiment: null };
      }
    }

    function parseSentimentorSignificance(value) {
      switch (parseInt(value)) {
        case -1:
          return NEGATIVE;
        case 0:
          return NEUTRAL;
        case 1:
          return POSITIVE;
        default:
          return NEUTRAL;
      }
    }

    function updateSentimentAnalysis(engineResult) {
      if (engineResult && engineResult.Sentiment) {
        switch (engineResult.Sentiment) {
          case "NEGATIVE":
            setAwsSentiment({ code: -1, sentiment: "Negative" });
            return -1;
          case "NEUTRAL":
            setAwsSentiment({ code: 0, sentiment: "Neutral" });
            return 0;
          case "POSITIVE":
            setAwsSentiment({ code: 1, sentiment: "Positive" });
            return 1;
          default:
            setAwsSentiment({ code: null, sentiment: null });
            return null;
        }
      } else {
        setAwsSentiment({ code: null, sentiment: "Error. Text too large" });
        return null;
      }
    }
    return (
      <Card className="mb-1" style={{ whiteSpace: "pre-wrap" }}>
        <Card.Body>
          <Card.Title>
            <div className="form-group">
              <label className="small mb-1" htmlFor="title">
                Title
              </label>
              <input
                className="form-control py-4"
                name="title"
                type="text"
                value={title}
                onChange={(e) => {
                  setTitle(e.target.value);
                }}
                placeholder="Enter title"
              />
              <Form.Text className="text-muted">
                (source: {props.row.source})
              </Form.Text>
            </div>
            <div className="form-group">
              <label className="small mb-1" htmlFor="text">
                Text
              </label>
              <TextareaAutosize
                className="form-control py-4"
                name="text"
                value={text}
                onChange={(e) => {
                  setText(e.target.value);
                }}
                placeholder="Enter text"
              />
            </div>
            <div className="form-group">
              <label className="small mb-1" htmlFor="summary">
                Summary
              </label>
              <TextareaAutosize
                className="form-control py-4"
                name="summary"
                value={summary}
                onChange={(e) => {
                  setSummary(e.target.value);
                }}
                placeholder="Enter summary"
              />
              <Form.Text className="text-muted">
                Aws comprehend analysis will be performed based on this field
              </Form.Text>
              <Button
                size="sm"
                className="mr-1 mb-1"
                onClick={() => setSummary(text)}
              >
                Copy from text
              </Button>
              <Button
                size="sm"
                className="mb-1"
                onClick={() => setSummary(title)}
              >
                Copy from title
              </Button>
            </div>
            <div className="form-group">
              <label className="small mb-1" htmlFor="significance">
                Significance
              </label>
              <select
                className="form-control mb-1"
                onChange={(e) => {
                  setSignificance(e.target.value);
                }}
                defaultValue={significance}
              >
                <option value={NEGATIVE}>Low</option>
                <option value={NEUTRAL}>Medium</option>
                <option value={POSITIVE}>High</option>
              </select>
            </div>
            <div className="form-group">
              <label className="small mb-1" htmlFor="sentiment">
                Sentiment
              </label>
              <select
                className="form-control mb-1"
                onChange={(e) => {
                  setSentiment(e.target.value);
                }}
                defaultValue={sentiment}
              >
                <option value={NEGATIVE}>Negative</option>
                <option value={NEUTRAL}>Neutral</option>
                <option value={POSITIVE}>Positive</option>
              </select>
            </div>
          </Card.Title>
          <p>Aws Sentiment: {awsSentiment.sentiment}</p>
          <Button disabled={buttonState.disabled} onClick={() => onSubmit()}>
            {buttonState.title}
          </Button>
          <Button
            variant="danger"
            className="float-right"
            onClick={() => onDelete()}
            disabled={deleteButtonState.disabled}
            title={deleteButtonState.title}
          >
            {deleteButtonState.title}
          </Button>
        </Card.Body>
      </Card>
    );
  }
  return (
    <>
      {props.data.map((row, ndx) => {
        return <DataRow key={`row_${ndx}`} row={row} />;
      })}
    </>
  );
}
